import { createSelector } from 'reselect';

export const selectSearchAll = state => state.searchAll;

export const selectQuery = createSelector(
  selectSearchAll,
  searchAll => searchAll.query,
);

export const selectIsLoading = createSelector(
  selectSearchAll,
  searchAll => searchAll.isLoading,
);

export const selectCategories = createSelector(
  selectSearchAll,
  searchAll => searchAll.categories,
);

export const selectCategoryById = createSelector(
  selectCategories,
  (_state, props) => props.id,
  (categories, id) => categories[id],
);
